import React from 'react';

import { useSelector } from 'react-redux';
import ResizeObserver from 'resize-observer-polyfill';

import { isMobileUa } from '../../../../../shared/features/uatraits';
import { GRID_ITEM_RATIO, GRID_VIEW } from '../../../constants';
import * as defaultHelpers from '../helpers/default-position';
import * as presenterHelpers from '../helpers/presenter-position';
import { PositionHelpers, useCommonLayoutStyles } from './useCommonLayoutStyles';

interface HookParams {
    nodeItemRatio: GRID_ITEM_RATIO;
    syntheticStartNodeCount: number;
    syntheticEndNodeCount: number;
    maxDisplayNodeCount: number;
    page: number;
    isScreenSharingActive?: boolean;
    handleResize(elem?: Element): void;
    shouldSwapSelfView?: boolean;
    isNewGrid?: boolean;
    /** Конструктор ResizeObserver - для PiP передаётся `pipWindow.ResizeObserver`. */
    ResizeObserverCtor?: typeof ResizeObserver;
}

export const useLayoutStyles = (gridView: GRID_VIEW, params: HookParams) => {
    const {
        page,
        maxDisplayNodeCount,
        nodeItemRatio,
        syntheticStartNodeCount,
        syntheticEndNodeCount,
        handleResize,
        shouldSwapSelfView,
        isScreenSharingActive,
        isNewGrid,
        ResizeObserverCtor = ResizeObserver,
    } = params;
    const isMobile = useSelector(isMobileUa);
    const defaultPositionHelpers = React.useMemo<PositionHelpers>(() => {
        return {
            getAreas: defaultHelpers.getAreaCreator(page, maxDisplayNodeCount, nodeItemRatio, isNewGrid),
            getStartButtonStyles: defaultHelpers.getStartButtonStyles,
            getEndButtonStyles: defaultHelpers.getEndButtonStyles,
        };
    }, [page, maxDisplayNodeCount, nodeItemRatio, isNewGrid]);

    const presenterPositionHelpers = React.useMemo<PositionHelpers>(() => {
        return {
            getAreas: presenterHelpers.getAreas({ shouldSwapSelfView, isNewGrid, isScreenSharingActive, isMobile }),
            getStartButtonStyles: presenterHelpers.getStartButtonStyles,
            getEndButtonStyles: presenterHelpers.getEndButtonStyles,
        };
    }, [shouldSwapSelfView, isNewGrid, isScreenSharingActive, isMobile]);

    const helpers = gridView === GRID_VIEW.DEFAULT ? defaultPositionHelpers : presenterPositionHelpers;

    return useCommonLayoutStyles(
        { syntheticStartNodeCount, syntheticEndNodeCount, handleResize, ResizeObserverCtor },
        helpers
    );
};
